import React, { useState, useEffect } from 'react';
import { FaInstagram, FaTiktok, FaAmazon } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";

// Importar las imágenes con las rutas correctas
import coverImage from '../../../assets/images/jdm-tecnicas/tapa.png';
import pagesImage from '../../../assets/images/jdm-tecnicas/paginas.png';

import UrlConfig from '../../../data/UrlConfig'; // <<-- AJUSTA ESTA RUTA A TU ARCHIVO UrlConfig.js

const API_URLS = UrlConfig; // Asumiendo que UrlConfig es un objeto directamente o una función que devuelve un objeto.


// Componente para el Popup de Flujo de Compra
const PurchaseFlowPopup = ({ isOpen, onClose, onSubmit, formData, handleChange, isLoading, error, currentStep, setCurrentStep }) => {
  if (!isOpen) return null;

  const handleNextStep = () => {
    if (!formData.selectedFormat) {
      // Usar un estado de error local para el popup para mostrar mensajes antes del submit final
      alert('Por favor, selecciona un formato antes de continuar.');
      return;
    }
    setCurrentStep('enterDetails');
  };

  const handleBackStep = () => {
    setCurrentStep('selectFormat');
  };

  const handleFinalSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, formData.selectedFormat);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-2xl shadow-lg border border-gray-700 p-8 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl font-bold"
        >
          &times;
        </button>
        <h2 className="text-2xl font-semibold text-center mb-4">
          ¡Quiero Mi Journal de Manifestación!
        </h2>

        {currentStep === 'selectFormat' && (
          <div className="flex flex-col gap-5">
            <p className="text-gray-300 text-center mb-4">
              Selecciona el formato que deseas:
            </p>
            <div className="flex flex-col gap-3">
              <label className="flex items-center space-x-3 text-white cursor-pointer bg-gray-800 p-3 rounded-lg border border-gray-700 hover:border-purple-500 transition">
                <input
                  type="radio"
                  name="selectedFormat"
                  value="ebook"
                  checked={formData.selectedFormat === 'ebook'}
                  onChange={handleChange}
                  className="form-radio text-purple-500 h-5 w-5"
                />
                <span>Ebook (Digital)</span>
              </label>
              <label className="flex items-center space-x-3 text-white cursor-pointer bg-gray-800 p-3 rounded-lg border border-gray-700 hover:border-purple-500 transition">
                <input
                  type="radio"
                  name="selectedFormat"
                  value="paperback"
                  checked={formData.selectedFormat === 'paperback'}
                  onChange={handleChange}
                  className="form-radio text-purple-500 h-5 w-5"
                />
                <span>Tapa Blanda (Físico)</span>
              </label>
              <label className="flex items-center space-x-3 text-white cursor-pointer bg-gray-800 p-3 rounded-lg border border-gray-700 hover:border-purple-500 transition">
                <input
                  type="radio"
                  name="selectedFormat"
                  value="hardcover"
                  checked={formData.selectedFormat === 'hardcover'}
                  onChange={handleChange}
                  className="form-radio text-purple-500 h-5 w-5"
                />
                <span>Tapa Dura (Físico)</span>
              </label>
            </div>
            <button
              onClick={handleNextStep}
              className="mt-6 py-3 rounded-lg font-semibold transition text-lg bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90"
            >
              Siguiente
            </button>
          </div>
        )}

        {currentStep === 'enterDetails' && (
          <form onSubmit={handleFinalSubmit} className="flex flex-col gap-5">
            <p className="text-gray-300 text-center mb-2">
              Por favor, ingresa tus datos para continuar:
            </p>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Tu nombre"
              className="px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-purple-500"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Tu email"
              className="px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-purple-500"
              required
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Tu celular (opcional)"
              className="px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-purple-500"
            />
            <button
              type="submit"
              className={`mt-2 py-3 rounded-lg font-semibold transition text-lg
                ${isLoading ? 'bg-gray-600 cursor-not-allowed' : 'bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90'}`}
              disabled={isLoading}
            >
              {isLoading ? 'Procesando...' : 'Método de pago y delivery'}
            </button>
            <button
              type="button"
              onClick={handleBackStep}
              className="mt-2 py-3 rounded-lg font-semibold transition text-lg bg-gray-700 hover:bg-gray-600 text-white"
            >
              Volver a seleccionar formato
            </button>
          </form>
        )}
        {error && <p className="text-red-500 text-center mt-4">{error}</p>}
      </div>
    </div>
  );
};


// NUEVO Componente para el Popup de Mensaje de Éxito
const SuccessMessagePopup = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-2xl shadow-lg border border-gray-700 p-8 max-w-md w-full relative text-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl font-bold"
        >
          &times;
        </button>
        <h2 className="text-3xl font-semibold text-green-400 mb-4">
          ¡Gracias por tu interés!
        </h2>
        <p className="text-gray-300 text-lg mb-6">
          {message}
        </p>
        <button
          onClick={onClose}
          className="mt-4 py-3 px-6 rounded-lg font-semibold transition text-lg bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90"
        >
          Entendido
        </button>
      </div>
    </div>
  );
};


const JournalLaunch = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", selectedFormat: "" });
  const [showPurchasePopup, setShowPurchasePopup] = useState(false);
  const [showSuccessMessagePopup, setShowSuccessMessagePopup] = useState(false); // Nuevo estado para el modal de éxito
  const [successMessageContent, setSuccessMessageContent] = useState(''); // Nuevo estado para el contenido del mensaje de éxito
  const [currentPurchaseStep, setCurrentPurchaseStep] = useState('selectFormat');
  const [timeLeft, setTimeLeft] = useState({});
  const launchDate = new Date('2025-11-11T00:00:00Z');

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(''); // El error se mostrará en el PurchaseFlowPopup

  const calculateTimeLeft = () => {
    const difference = +launchDate - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0, launched: true };
    }
    return timeLeft;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError(''); // Limpiar errores al cambiar los campos
  };

  const handleSubmit = async (e, selectedFormat) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Validación básica en el frontend
    if (!formData.name.trim() || !formData.email.trim()) {
      setError('Por favor, ingresa tu nombre y correo electrónico.');
      setIsLoading(false);
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('Por favor, ingresa un correo electrónico válido.');
      setIsLoading(false);
      return;
    }
    if (!selectedFormat) {
        setError('No se ha seleccionado un formato para el Journal.');
        setIsLoading(false);
        return;
    }

    try {
      const newsletterValue = `journal_manifestation_${selectedFormat}`;

      const response = await fetch(API_URLS.leads_action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
          nick: formData.name,
          phone: formData.phone,
          page: 'JournalLaunchPage',
          section: 'purchase_flow',
          status: 'JournalInterest',
          folder: 'journal-launch-page',
          product_format: selectedFormat,
          newsletter: [newsletterValue]
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessageContent('Me contactaré contigo para coordinar la entrega.');
        setFormData({ name: "", email: "", phone: "", selectedFormat: "" }); // Resetear el formulario
        setShowPurchasePopup(false); // Cierra el modal de compra
        setShowSuccessMessagePopup(true); // Abre el modal de éxito
        setCurrentPurchaseStep('selectFormat'); // Resetear el paso del modal de compra para la próxima vez
      } else {
        throw new Error(data.message || 'Ocurrió un error al procesar tu solicitud.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col">
      {/* Fondo gradiente */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-black to-gray-900 opacity-95"></div>

      <main className="relative z-10 flex-grow container mx-auto px-6 lg:px-20 py-12 flex flex-col items-center max-w-7xl">
        <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-center lg:text-5xl">
          Journal de Manifestación ✨
        </h1>
        {/* Sección de imágenes */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 mb-8 w-full max-w-6xl">
          <div className="w-full max-w-md lg:w-2/5 flex flex-col items-center">
            <img
              src={coverImage}
              alt="Tapa del Journal de Manifestación"
              className="rounded-xl shadow-2xl border border-gray-700 object-cover w-full"
            />
            {/* Subtítulo debajo de la imagen de la portada */}
            <p className="text-gray-400 max-w-xs text-center mt-6 text-base sm:text-lg lg:text-xl">
              Un diario diseñado para alinear tu visión, deseo y creencia.
              Descubre las técnicas más efectivas para manifestar tu propósito.
            </p>
          </div>

          <img
            src={pagesImage}
            alt="Páginas interiores del Journal de Manifestación"
            className="w-full max-w-3xl lg:w-3/5 rounded-xl shadow-2xl border border-gray-700 object-contain"
          />
        </div>

        <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-center lg:text-5xl">
          Vista Previa
        </h1>
        {/* FlipHTML5 Preview */}
        <div className="w-full max-w-5xl mb-14 shadow-2xl rounded-2xl overflow-hidden border border-gray-700">
          <div style={{ position: "relative", paddingTop: "max(60%,324px)", width: "100%", height: 0 }}>
            <iframe
              style={{ position: "absolute", border: "none", width: "100%", height: "100%", left: 0, top: 0 }}
              src="https://online.fliphtml5.com/siete-llaves/mdsd/"
              seamless="seamless"
              scrolling="no"
              frameBorder="0"
              allowTransparency={true}
              allowFullScreen={true}
              title="Journal Preview"
            ></iframe>
          </div>
        </div>

        {/* Beneficios del Journal */}
        <div className="max-w-3xl text-center mb-10">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-center lg:text-5xl">
            Lo que vas a lograr con este Journal
          </h2>
          <ul className="text-gray-300 space-y-3 text-lg">
            <li>• Claridad en tu visión</li>
            <li>• Encender tu deseo</li>
            <li>• Fortalecer tu creencia</li>
            <li>• Practicar aceptación</li>
            <li>• Crear intención consciente</li>
            <li>• Pasar a la acción</li>
            <li>• Aprender a soltar (desapego)</li>
          </ul>
        </div>

        {/* Puedes descomentar el contador si quieres */}
        {/* {timeLeft.launched ? (
          <p className="text-xl font-bold text-green-400 mb-8">¡El Journal ya está disponible!</p>
        ) : (
          <div className="text-center mb-8 bg-gray-900/50 p-6 rounded-xl border border-gray-700">
            <p className="text-gray-300 text-lg mb-4">Lanzamiento oficial: ¡Faltan sólo!</p>
            <div className="flex justify-center items-center space-x-4">
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.days || '0'}</span>
                <span className="text-sm text-gray-400">Días</span>
              </div>
              <span className="text-4xl font-bold text-gray-500">:</span>
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.hours || '0'}</span>
                <span className="text-sm text-gray-400">Horas</span>
              </div>
              <span className="text-4xl font-bold text-gray-500">:</span>
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.minutes || '0'}</span>
                <span className="text-sm text-gray-400">Minutos</span>
              </div>
              <span className="text-4xl font-bold text-gray-500">:</span>
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.seconds || '0'}</span>
                <span className="text-sm text-gray-400">Segundos</span>
              </div>
            </div>
          </div>
        )} */}

        {/* Botón "Quiero Mi Journal" que activa el popup de compra */}
        <button
          onClick={() => {
            setShowPurchasePopup(true);
            setCurrentPurchaseStep('selectFormat'); // Asegurarse de que empieza en el primer paso
            setError(''); // Limpiar errores al abrir el popup
          }}
          className="px-8 py-4 bg-yellow-500 text-black font-semibold rounded-lg shadow-lg hover:bg-yellow-400 transition text-xl mb-16"
        >
          Quiero Mi Journal
        </button>
      </main>

      {/* Footer con Redes Sociales */}
      <footer className="relative z-10 text-center py-8 text-sm text-gray-600 flex flex-col items-center">
        <div className="flex justify-center gap-8 text-3xl text-gray-400 mb-4">
          <a href="https://instagram.com/gus.cuantico" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaInstagram />
          </a>
          <a href="https://www.tiktok.com/@ingeniero.consciente" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaTiktok />
          </a>
          <a href="https://www.youtube.com/@simanifiesta" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaYoutube />
          </a>
          <a href="https://www.amazon.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaAmazon />
          </a>
        </div>
        © {new Date().getFullYear()} Gus • Aguiar | En misión de elevar y transformar.
      </footer>

      {/* Popup de Flujo de Compra */}
      <PurchaseFlowPopup
        isOpen={showPurchasePopup}
        onClose={() => {
            setShowPurchasePopup(false);
            setCurrentPurchaseStep('selectFormat'); // Resetear el paso al cerrar el popup
            setFormData(prev => ({ ...prev, selectedFormat: "" })); // Limpiar formato seleccionado
            setError(''); // Limpiar errores
        }}
        onSubmit={handleSubmit}
        formData={formData}
        handleChange={handleChange}
        isLoading={isLoading}
        error={error} // Pasar el error para que el popup lo muestre
        currentStep={currentPurchaseStep}
        setCurrentStep={setCurrentPurchaseStep}
      />

      {/* NUEVO: Popup de Mensaje de Éxito */}
      <SuccessMessagePopup
        isOpen={showSuccessMessagePopup}
        onClose={() => setShowSuccessMessagePopup(false)}
        message={successMessageContent}
      />
    </div>
  );
};

export default JournalLaunch;